<template>
    <span>
        <Button
            :class-array="classArray"
            :color="color"
            :disabled="disabled"
            :icon="icon"
            :iconSize="iconSize"
            :loading="loading"
            :size="size"
            @click="handleButtonClick">
            <slot></slot>
        </Button>
        <ConfirmationModal :id="`${ id }-modal`"
                           :confirmation-button-color="confirmationButtonColor"
                           @confirmed="$emit('confirmed'); modal?.hide()">
            <template v-slot:title>{{ confirmationTitle }}</template>
            <template v-slot:text><slot name="confirmationText">{{ confirmationText }}</slot></template>
            <template v-slot:confirm-button-text>{{ confirmationButtonText }}</template>
        </ConfirmationModal>
    </span>
</template>

<script setup lang="ts">
import { Modal } from "bootstrap";
import { onMounted, ref, Ref, useId } from "vue";
import Button from '@components/Button.vue'
import ConfirmationModal from './ConfirmationModal.vue'

const { color, size, loading, disabled, confirmationTitle, confirmationButtonColor, confirmationButtonText, confirmationText, icon, classArray } = defineProps({
    color: {
        required: false,
        type: String,
        default: 'primary',
    },
    size: {
        required: false,
        type: String,
        default: 'medium',
    },
    loading: {
        required: false,
        type: Boolean,
        default: false,
    },
    disabled: {
        required: false,
        type: Boolean,
        default: false,
    },
    confirmationTitle: {
        required: false,
        type: String,
        default: 'Are you sure?',
    },
    confirmationButtonText: {
        required: false,
        type: String,
        default: 'Continue',
    },
    confirmationText: {
        required: false,
        type: String,
        default: 'Are you sure you wish to continue with this change?',
    },
    confirmationButtonColor: {
        type: String,
        default: 'primary'
    },
    icon: {
        required: false,
    },
    iconSize: {
        required: false,
        type: String,
        default: '14',
    },
    classArray: {
        required: false,
        type: Array,
        default() {
            return []
        },
    }
})
const emit = defineEmits(['confirmed']);

const modal: Ref<Modal | undefined> = ref();
const id: string = useId()

const handleButtonClick = (): void => modal.value?.show()

onMounted(() => {
    modal.value = new Modal(document.getElementById(`${ id }-modal`) as Element)
})
</script>

<style scoped>

</style>
